import { Button, Stack, Typography } from '@mui/material'
import { useActiveOrganization } from 'hooks/use-organization'
import { useAuthToken } from 'hooks/use-auth-token'
import { ReactComponent as JelledLogo } from '../NavBar/jelled-final-logo.svg'
import { ReactComponent as DeletionGraphic } from './deletion-graphic.svg'
import { COLORS } from 'app-constants'
import { useUpdateKeyContext } from 'hooks/use-context-key'

const DeletionRequested = () => {
  const [, setAuthToken] = useAuthToken()
  const [, setActiveOrganization] = useActiveOrganization()
  const updateKey = useUpdateKeyContext()

  const onLogoutClick = () => {
    setAuthToken(null)
    setActiveOrganization(null)

    updateKey()

    // clear session storage
    sessionStorage.clear()
  }

  return (
    <Stack width="100vw" height="100vh" justifyContent="center" alignItems="center">
      <Stack position="fixed" top="24px">
        <JelledLogo
          style={{
            width: '126px',
            height: '30px',
          }}
        />
      </Stack>

      <DeletionGraphic />

      <Typography variant="h3">Your account is in the process of being deleted.</Typography>

      <Typography
        sx={{
          my: 3,
        }}>
        If you think this is an error, please contact{' '}
        <a
          href="mailto:support@jelled.ai"
          style={{
            textDecoration: 'underline',
          }}>
          support@jelled.ai
        </a>
      </Typography>

      <Button
        size="medium"
        variant="contained"
        onClick={onLogoutClick}
        sx={{
          background: COLORS.JELLED_PRIMARY_BLUE,
          width: 'fit-content',
          p: '12px 40px',
        }}>
        Log out
      </Button>
    </Stack>
  )
}

export default DeletionRequested
